import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const AuthLogin = Loadable(
  lazy(() => import('views/pages/authentication/authentication/Login'))
);
const AuthForgetPassword = Loadable(
  lazy(() => import('views/pages/authentication/authentication/ForgetPassword'))
);
const AuthVerifyOtp = Loadable(
  lazy(() => import('views/pages/authentication/authentication/VerifyOTP'))
);
const AuthResetPassword = Loadable(
  lazy(() => import('views/pages/authentication/authentication/ResetPassword'))
);
const AuthRegister = Loadable(
  lazy(() => import('views/pages/authentication/authentication/Register3'))
);

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <AuthLogin />,
    },
    {
      path: '/login',
      element: <AuthLogin />,
    },
    {
      path: '/forgetpassword',
      element: <AuthForgetPassword />,
    },
    {
      path: '/verifyOtp',
      element: <AuthVerifyOtp />,
    },
    {
      path: '/resetpassword/:id',
      element: <AuthResetPassword />,
    },
    {
      path: '/signup',
      element: <AuthRegister />,
    },
  ],
};

export default AuthenticationRoutes;
